<template>
    <main class="detail">
        <!-- Hero -->
        <section class="hero" aria-labelledby="page-title">
            <div class="section__inner hero__inner">
                <h2 id="page-title">교육안내</h2>
            </div>
        </section>

        <!-- 상단 제목/브레드크럼 -->
        <div class="section__inner">
            <nav class="crumbs" aria-label="breadcrumb">
                <ol>
                    <li><a href="/noticeList">교육안내</a></li>
                    <li aria-current="page">상세</li>
                </ol>
            </nav>

            <header class="detail-header">
                <h1 class="detail-title">{{ state.title }}</h1>
                <!-- <p class="detail-sub">2025-10-13 게시 · 공개</p> -->
            </header>

            <!-- 메타 블록 -->
            <section class="meta" aria-label="게시 정보">
                <dl class="meta-grid">
                    <div>
                        <dt>작성일</dt>
                        <dd>{{ state.updatedAt ? state.updatedAt.slice(0, 10) : '-' }}</dd>
                    </div>
                    <!-- <div>
            <dt>공개여부</dt><dd>공개</dd>
          </div> -->
                    <div>
                        <dt>접수기간</dt>
                        <dd>{{ state.startAt?.slice(0, 10) }} ~ {{ state.endAt?.slice(0, 10) }}</dd>
                    </div>
                    <div>
                        <dt>조회수</dt>
                        <dd>{{ state.viewCount }}</dd>
                    </div>
                </dl>
            </section>

            <!-- 본문 -->
            <article class="content1" aria-label="본문">
                <h2 class="sr-only">본문</h2>

                <!-- 본문 하단 이미지 나열 -->
                <div class="content-images" v-if="existingImgFiles.length">
                    <figure v-for="(img, i) in existingImgFiles" :key="`content-img-${i}-${img.name}`"
                        class="content-image">
                        <img :src="apiBaseUrl + img.name" :alt="fileNameOnly(img.name)" loading="lazy"
                            @error="($event) => $event.target.style.display = 'none'" />
                        <!-- 캡션이 필요 없으면 제거 가능 -->
                        <!-- <figcaption>{{ fileNameOnly(img.name) }}</figcaption> -->
                    </figure>
                </div>
            <!-- 본문 텍스트 -->
            <p v-if="state.content" class="answer-text">
                {{ state.content }}
            </p>

                <!-- 필요 시 교육 요약 카드 (날짜/장소/문의) -->
                <ul class="summary-cards" aria-label="교육 요약">
                    <li>
                        <strong>교육일정</strong>
                        <span>{{ state.eduStartAt?.slice(0, 10) }} ~ {{ state.eduEndAt?.slice(0, 10) }}</span>
                    </li>
                    <li>
                        <strong>장소</strong>
                        <span>{{ state.location }}</span>
                    </li>
                    <li>
                        <strong>문의</strong>
                        <span>{{ state.inquiry }}</span>
                    </li>
                </ul>
            </article>

            <!-- 첨부파일 -->
            <section class="attachment" aria-labelledby="att-title" v-if="existingFiles.length">
                <h2 id="att-title" class="section-title">첨부파일</h2>

                <ul class="file-list">
                <li class="file" v-for="(f, i) in existingFiles" :key="`file-${i}-${f.name}`">
                    <i class="fa-regular fa-file-lines" aria-hidden="true"></i>
                    <span class="file-name" :title="fileNameOnly(f.name)">
                    {{ fileNameOnly(f.name) }}
                    </span>
                    <!-- 파일 크기는 백엔드에서 제공 시에만 노출 (없으면 숨김) -->
                    <!-- <span class="file-size">{{ f.sizeText }}</span> -->
                    <button class="btn-link" @click="downloadFile(f.name)">다운로드</button>
                </li>
                </ul>
            </section>

            <!-- 이미지 갤러리 -->
            <!-- <section class="gallery" aria-labelledby="img-title">
                <h2 id="img-title" class="section-title">이미지</h2>
                <ul class="gallery-grid">
                    <li>
                        <img src="/src/assets/traingMain.jpeg" alt="교육 홍보 이미지 1" />
                    </li>
                </ul>
            </section> -->

            <!-- 하단 네비게이션 -->
            <!-- <nav class="post-nav" aria-label="이전 다음 글">
                <a class="post-nav__item prev" href="#"><span>이전글</span><strong>9월 내부통제 워크숍 안내</strong></a>
                <a class="post-nav__item next" href="#"><span>다음글</span><strong>11월 온라인 세미나 공지</strong></a>
            </nav> -->

            <!-- 액션 바 (목록/인쇄) -->
            <div class="actionbar">
                <button @click="go('/traininglsit')" class="btn-primary" aria-label="목록으로 이동">목록으로</button>
                <!-- <button class="btn-ghost" onclick="window.print()" aria-label="이 페이지 인쇄">인쇄</button> -->
            </div>
        </div>
    </main>
</template>

<script setup>
import { ref, computed, reactive, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { updateViewCount, getEduGuidDetail } from '@/api/edu'
import axios from 'axios';
const checkUserId = computed(() => store.state.temp.userInfo)
const router = useRouter()
const route = useRoute()
const store = useStore()
// 주요행사 초기값 설정 (작성일은 기본적으로 오늘 날짜)
const state = reactive({
    title: '',
    content: '',
    startAt:'',
    endAt:'',
    eduStartAt:'',
    eduEndAt:'',
    pinned: false,
    location: '',
    inquiry: '',
    viewCount: 0
})


const existingFiles = ref([])     // 서버 파일 이름

function go(to) {
  router.push(to)
}

const existingImgFiles = ref([])     // 이미지서버 파일 이름

const handleCancel = () => {
    router.back()
}

const VIEW_TTL_MS = 15 * 60 * 1000 // 15분

function getKey(eduId) {
    return `edu-viewed-${eduId}`
}
function shouldIncreaseView(eduId) {
    const last = Number(localStorage.getItem(getKey(eduId)) || 0)
    return Date.now() - last >= VIEW_TTL_MS
}
function markViewed(eduId) {
    localStorage.setItem(getKey(eduId), String(Date.now()))
}

async function loadDetailAndMaybeIncrement(eduId) {
    if (!eduId) return

    // 1) 조회수 증가 (15분 TTL)
    try {
        if (shouldIncreaseView(eduId)) {
            await updateViewCount({ eduId })
            // 낙관적 증가 (곧 상세 조회로 다시 덮어씌워짐)
            if (state.viewCount != null) state.viewCount += 1
            markViewed(eduId)
        }
    } catch (e) {
        console.warn('뷰 카운트 업데이트 실패:', e)
    }

    // 2) 상세 조회
    const result = await getEduGuidDetail({ eduId })
    if (result?.result === 'ok') {
        state.eduId = result.data.eduId
        state.title = result.data.title
        state.content = result.data.content
        state.startAt = result.data.startAt
        state.endAt = result.data.endAt
        state.eduStartAt = result.data.eduStartAt
        state.eduEndAt = result.data.eduEndAt
        state.createdAt = result.data.createdAt
        state.updatedAt = result.data.updatedAt
        state.adminName = result.data.adminName
        state.pinned = result.data.pinned
        state.location = result.data.location
        state.inquiry = result.data.inquiry
        state.viewCount = result.data.viewCount

        const fileFields = [
            result.data.eduFile1, result.data.eduFile2, result.data.eduFile3,
            result.data.eduFile4, result.data.eduFile5, result.data.eduFile6,
            result.data.eduFile7,
        ]
        existingFiles.value = fileFields.filter(Boolean).map(name => ({ name }))

        const imgFileFields = [
            result.data.eduImgFile1, result.data.eduImgFile2, result.data.eduImgFile3,
        ]
        existingImgFiles.value = imgFileFields.filter(Boolean).map(name => ({ name }))
    }
}


onMounted(async () => {
    const eduId = route.query?.eduId
    loadDetailAndMaybeIncrement(eduId)
})

watch(() => route.query.eduId, (newId, oldId) => {
    if (newId && newId !== oldId) loadDetailAndMaybeIncrement(newId)
})

const apiBaseUrl = process.env.VUE_APP_API_URL; // 환경변수에서 API URL 가져오기

const downloadFile = async (filePath) => {
    try {
        // filePath가 절대 URL이라면 호스트/포트를 제거해 상대 경로만 추출
        // 예: http://localhost:8020/up_imgs/...  →  /up_imgs/...
        const relativePath = filePath.replace(/^https?:\/\/[^/]+/, '')

        // apiBaseUrl + 상대 경로를 합쳐 백엔드에서 직접 다운로드
        const downloadUrl = `${apiBaseUrl}${relativePath}`

        console.log('다운로드 요청 URL:', downloadUrl)

        const response = await axios({
            url: downloadUrl,
            method: 'GET',
            responseType: 'blob'
        })

        const blob = new Blob([response.data])
        const url = window.URL.createObjectURL(blob)

        // 파일명만 추출
        const fileName = fileNameOnly(relativePath)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
    } catch (error) {
        console.error('파일 다운로드 실패:', error)
        alert('파일 다운로드 중 문제가 발생했습니다.')
    }
}

const downloadImgFile = async (filePath) => {
    try {
        // filePath가 절대 URL이라면 호스트/포트를 제거해 상대 경로만 추출
        // 예: http://localhost:8020/up_imgs/...  →  /up_imgs/...
        const relativePath = filePath.replace(/^https?:\/\/[^/]+/, '')

        // apiBaseUrl + 상대 경로를 합쳐 백엔드에서 직접 다운로드
        const downloadUrl = `${apiBaseUrl}${relativePath}`

        console.log('다운로드 요청 URL:', downloadUrl)

        const response = await axios({
            url: downloadUrl,
            method: 'GET',
            responseType: 'blob'
        })

        const blob = new Blob([response.data])
        const url = window.URL.createObjectURL(blob)

        // 파일명만 추출
        const fileName = fileNameOnly(relativePath)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
    } catch (error) {
        console.error('파일 다운로드 실패:', error)
        alert('파일 다운로드 중 문제가 발생했습니다.')
    }
}

const fileNameOnly = (fullPath) => {
    if (!fullPath) return ''
    return fullPath.split('/').pop()
}

</script>

<style src="./index.css" scoped></style>
